import React from 'react';

const SolidLineIcon: React.FC = ({width, height}: any) => (
    <svg
        width={width}
        height={height}
        fill="none"
        viewBox="0 2 38 2"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fillRule="evenodd" clipRule="evenodd" d="M38 4H0V2h38v2z" fill="currentColor" />
    </svg>
);

export default SolidLineIcon;
